import { sortBySequenceNumber } from 'shared/lib/common-util'
import { fromAdditionalReferenceResponse, toCreateAdditionalReferenceRequest } from '../models/mapper'
import { AdditionalReferenceCreate } from '../models/request'
import { AdditionalReference, AdditionalReferenceParentType } from '../models/types'
import { createDraftAdditionalReferencesV2 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function createDraftAdditionalReferences(
  parentId: number,
  parentType: AdditionalReferenceParentType,
  data: AdditionalReferenceCreate[],
): Promise<AdditionalReference[]> {
  const requests = data.map((d) => toCreateAdditionalReferenceRequest(parentId, parentType, d))
  const responses = await createDraftAdditionalReferencesV2(requests)

  return responses.map((
    response,
    index,
  ) => fromAdditionalReferenceResponse(response, parentType, parentId, index))
    .sort(sortBySequenceNumber)
}
